var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.userActivities,"loading":_vm.loading,"options":_vm.options,"server-items-length":_vm.total},on:{"update:options":function($event){_vm.options=$event}},scopedSlots:_vm._u([{key:"item.id",fn:function(ref){
var item = ref.item;
return [_c('v-chip',{attrs:{"pill":""}},[_vm._v(_vm._s(item.id))])]}},{key:"item.action",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.activityTitle[item.action])+" ")]}},{key:"item.entity_id",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.entity.title)+" ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }